import { render } from "./PatientCreateOffcanvas.vue?vue&type=template&id=2cdb94a1&scoped=true"
import script from "./PatientCreateOffcanvas.vue?vue&type=script&lang=js"
export * from "./PatientCreateOffcanvas.vue?vue&type=script&lang=js"

import "./PatientCreateOffcanvas.vue?vue&type=style&index=0&id=2cdb94a1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdb94a1"]])

export default __exports__